module.exports = __webpack_public_path__ + "static/media/b1_p7_clickable.7e0adb75.png";